var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"selector month-selector",attrs:{"clearable":false,"searchable":_vm.allowSearch,"options":_vm.months,"value":_vm.months[_vm.selectedMonth],"reduce":m => m.id},on:{"input":_vm.changeMonth,"search:focus":_vm.fixHighlight}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v(" Insira um mês válido ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }